module.exports = __webpack_public_path__ + "static/bulletsurf-49702c19ad5fbcaa31e7f8592535a778.gif";